// Raw parse output: a grid of strings, before any column mapping (T05).
// rows[i] is row i + 1 of the file as the operator sees it in Excel, so blank
// rows are kept; the normaliser skips them.
// Cells are strings only. Spreadsheet dates and times arrive as ISO-style text
// ("2026-06-13", "09:00", "2026-06-13 09:00") so later steps never handle Excel
// serial numbers or JavaScript Date objects.

export type RawFormat = 'csv' | 'xlsx';
export type TextEncodingName = 'utf-8' | 'windows-1252';

export interface RawTable {
  format: RawFormat;
  rows: string[][];
  /** CSV only: the encoding the file was decoded with. */
  encoding?: TextEncodingName;
  /** CSV only: the detected delimiter. */
  delimiter?: string;
  /** Spreadsheet only: the sheet these rows came from. */
  sheetName?: string;
  /** Spreadsheet only: every sheet in the workbook, for the sheet picker. */
  sheetNames?: string[];
}

export type ParseErrorCode = 'too-large' | 'empty' | 'unsupported' | 'unreadable' | 'timeout';

export type ParseResult =
  { ok: true; table: RawTable } | { ok: false; error: ParseErrorCode; message: string };

/** Largest file accepted, in bytes (docs/tickets.md T04). */
export const MAX_FILE_BYTES = 5 * 1024 * 1024;

export const PARSE_ERROR_MESSAGES: Record<ParseErrorCode, string> = {
  'too-large': 'This file is larger than 5 MB. Try exporting a shorter date range.',
  empty: "This file doesn't contain any rows.",
  unsupported:
    'ShiftLens can read CSV and Excel (.xlsx) files. Please export your rota as one of those.',
  unreadable: "This file couldn't be read. It may be damaged, or not a rota export.",
  timeout: 'Reading this file took too long, so we stopped. Try a smaller export.',
};

export function parseError(error: ParseErrorCode): ParseResult {
  return { ok: false, error, message: PARSE_ERROR_MESSAGES[error] };
}
